import { createSlice } from '@reduxjs/toolkit';

interface OrderState {
  newOrders: Order[];
  lastOrderId: number | null;
  newOrderCount: number;
  isSoundEnabled: boolean;
  siteEntryTime: string | null; // Siteye giriş zamanı
}

const initialState: OrderState = {
  newOrders: [],
  lastOrderId: null,
  newOrderCount: 0,
  isSoundEnabled: false,
  siteEntryTime: null,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setLastOrderId: (state, { payload }: { payload: number }) => {
      state.lastOrderId = payload;
    },
    setNewOrderCount: (state, { payload }: { payload: number }) => {
      state.newOrderCount = payload;
    },
    addNewOrder: (state, { payload }: { payload: Order }) => {
      // Aynı sipariş varsa ekleme
      const existingOrder = state.newOrders.find(
        (order: Order) => order.id === payload.id,
      );
      if (!existingOrder) {
        state.newOrders.unshift(payload);
      }
    },
    clearNewOrders: (state) => {
      state.newOrders = [];
    },
    setIsSoundEnabled: (state, { payload }: { payload: boolean }) => {
      state.isSoundEnabled = payload;
    },
    setSiteEntryTime: (state, { payload }: { payload: string }) => {
      state.siteEntryTime = payload;
    },
    resetOrderState: (state) => {
      state.newOrders = [];
      state.lastOrderId = null;
      state.newOrderCount = 0;
      state.isSoundEnabled = false;
      state.siteEntryTime = null;
    },
  },
});

export const orderActions = orderSlice.actions;
export const orderReducer = orderSlice.reducer;
